<template>
  <div class="migration-banner">
    <font-awesome-icon icon="exclamation-circle" class="migration-banner-icon" />
    <div class="migration-banner-text">
      <h3 class="migration-banner-title">{{ $t('MyISA is moving to a new address') }}</h3>
      <p class="migration-banner-detail">
        {{ $t('This application will be shut down at the end of {year}. The new version of MyISA is already available on {host}.', { year: decommissionYear, host: newAppHost }) }}
        {{ $t('For more information, contact us at ') }}<a :href="'mailto:' + supportEmail">{{ supportEmail }}</a>.
      </p>
    </div>
    <a :href="newAppUrl" class="migration-banner-cta">{{ $t('Go to the new MyISA') }}</a>
  </div>
</template>

<script>
import MIGRATION from '@/constants/migration';

export default {
  data() {
    return {
      newAppUrl: MIGRATION.newAppUrl,
      newAppHost: MIGRATION.newAppHost,
      supportEmail: MIGRATION.supportEmail,
      decommissionYear: MIGRATION.decommissionYear,
    };
  },
};
</script>

<style scoped>
.migration-banner {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  border-left: 6px solid #ED8934;
  background-color: #FDF3E7;
  color: #4b3a25;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
}

.migration-banner-icon {
  flex: 0 0 auto;
  font-size: 2rem;
  color: #ED8934;
}

.migration-banner-text {
  flex: 1 1 300px;
}

.migration-banner-title {
  margin: 0 0 .25rem 0;
  font-weight: 700;
  color: #4b3a25;
}

.migration-banner-detail {
  margin: 0;
  font-size: 1rem;
}

.migration-banner-detail a {
  color: #4D3397;
  text-decoration: underline;
}

.migration-banner-cta {
  flex: 0 0 auto;
  padding: .6rem 1.4rem;
  border-radius: 20px;
  background-color: #4D3397;
  color: #fff !important;
  font-weight: 600;
  white-space: nowrap;
}

.migration-banner-cta:hover {
  background-color: #3d2879;
  text-decoration: none;
}
</style>
